import * as angular from "angular";

/* @ngInject */
function getPricePlanPreferenceInputTime() {
  // Returns template of input according to the preference's data type
  // data type represents what the 'value'/'parentValue' type such as Float/Price/String etc...
  return function (preference) {
    const templateDir = 'app/modules/price-plan/directives/price-plan-preferences/price-place-prefrence-input-templates/';
    switch (preference.dataType) {
      case 'Percent': {
        return templateDir + 'price-plan-preference-type-percent.tmpl.html';
      }
      case 'Price': {
        return templateDir + 'price-plan-preference-type-currency.tmpl.html';
      }
      case 'String': {
        return templateDir + 'price-plan-preference-type-string.tmpl.html';
      }
      case 'DayTime': {
        return templateDir + 'price-plan-preference-type-day-time.tmpl.html';
      }
      case 'Minutes': {
        return templateDir + 'price-plan-preference-type-minutes.tmpl.html';
      }
      case 'Formula': {
        return templateDir + 'price-plan-preference-type-formula.tmpl.html';
      }
      case 'Currency' : {
        return templateDir + 'price-plan-preference-type-string.tmpl.html';
      }
      case 'Boolean' : {
        return templateDir + 'price-plan-preference-type-boolean.tmpl.html';
      }
    }
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .factory('getPricePlanPreferenceInputTime', getPricePlanPreferenceInputTime);
